<template>
  <section class="main_kiji_area mt25">
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area"
    >
      <preview-text-count
        name="メインタイトル"
        :count-target="mainTitle"
      />
      <preview-text-count
        name="メイン記事"
        :count-target="mainBody"
      />
    </div>
    <div class="fig_pr_area mb20">
      <figure class="object large">
        <img
          v-if="mainPhotoId"
          :id="targetIdMap.mainPhoto"
          :alt="jobName"
          :src="userImageUrl + mainPhotoId"
          data-test="main-photo"
          @load="$emit('onLoadImage')"
          @error="$emit('onLoadImage')"
        >
      </figure>
      <h3
        class="mod-title-lv2 mt15"
        style="min-width:440;"
      >
        この求人の特色<span class="size-small">（<a
          target="_blank"
          style="cursor: pointer;"
          :href="userHelpMarkURL"
        >アイコンの説明</a>）</span>
      </h3>
      <ul
        class="pr_icon"
      >
        <li
          v-for="(jobPr,i) in prIcons"
          :id="targetIdMap.jobPrIcons[jobPr.id]"
          :key="i"
          :class="jobPr.class"
          :data-test="`job-pr-${i}`"
          v-text="jobPr.name"
        />
      </ul>
    </div>
    <h2
      :id="targetIdMap.mainTitle"
      class="main-catch pega-pre-wrap"
      data-test="main-title"
      v-text="mainTitle.value"
    />
    <p
      :id="targetIdMap.mainBody"
      class="m_txt mt20 pega-pre-wrap"
      data-test="main-body"
      v-text="mainBody.value"
    />
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon],
  props: {
    mainPhotoId: {
      type: Number,
      default: 0
    },
    jobName: {
      type: String,
      required: true
    },
    jobPrIcons: {
      type: Array,
      default: () => []
    },
    mainTitle: {
      type: Object,
      required: true
    },
    mainBody: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      prIcon: 'prIconDisplayMaster'
    }),
    prIcons () {
      return this.prIcon.map(i => {
        return {
          id: i.id,
          name: i.name,
          class: this.jobPrIcons.includes(i.id) ? 'on' : 'off'
        }
      })
    }
  },
  created () {
    this.storeMaster('prIconDisplay')
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
